// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v8JghCVLbQeK4iVCV0h3 {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid transparent;
  transition: border-color 0.6s;
}
.v8JghCVLbQeK4iVCV0h3 > header {
  position: sticky;
  top: 0;
  background-color: var(--bar-background);
  width: 100%;
  user-select: none;
}
.v8JghCVLbQeK4iVCV0h3 > header > .toolbar {
  flex: 20px 0 0 ;
  display: flex;
  justify-content: end;
}
.v8JghCVLbQeK4iVCV0h3 > header > .toolbar > button {
  flex: 20px 0 0;
  height: 20px;
  padding: 2px;
  cursor: pointer;
}
.v8JghCVLbQeK4iVCV0h3 > header > .path {
  width: 100%;
  display: flex;
  gap: 0.5em;
  align-items: center;
  padding-left: 0.5em;
}
.v8JghCVLbQeK4iVCV0h3 > header > .path button {
  flex: 1em 0 0;
  height: 1.4em;
  color: var(--bar-color);
  font-size: 1.2em;
  cursor: pointer;
}
.v8JghCVLbQeK4iVCV0h3 > header > .path button:hover {
  background-color: var(--hover-background);
}
.v8JghCVLbQeK4iVCV0h3 > header > .path button:disabled {
  cursor: default;
  opacity: 0.6;
}
.v8JghCVLbQeK4iVCV0h3 > header > .path button:disabled:hover {
  background-color: transparent;
}
.v8JghCVLbQeK4iVCV0h3 > header > .path div {
  flex: 100% 1 1;
  overflow-y: hidden;
}
.v8JghCVLbQeK4iVCV0h3 > .list {
  flex: 100% 1 1;
  overflow: auto;
}
.v8JghCVLbQeK4iVCV0h3 > footer {
  background-color: var(--bar-background);
  flex: 1.5em 0 0;
  padding: 0 1em;
  font-size: 0.9em;
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
}
.v8JghCVLbQeK4iVCV0h3.focused {
  border-color: var(--active-border-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `v8JghCVLbQeK4iVCV0h3`,
	"toolbar": `toolbar`,
	"path": `path`,
	"list": `list`,
	"focused": `focused`
};
export default ___CSS_LOADER_EXPORT___;
